import React from 'react';
import { Outlet } from 'react-router-dom';
import { AnnouncementBar } from './AnnouncementBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
export function SiteLayout() {
  return <div className="flex min-h-screen w-full flex-col bg-[#fffdf6]" data-id="element-355" data-mp="jgwoyg6vlirp">
      <ScrollToTop data-id="element-356" data-mp="ejwl8bxi0s3r" />
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-brand-navy focus:px-5 focus:py-3 focus:font-display focus:text-sm focus:font-semibold focus:text-white" data-id="element-357" data-mp="ejef8nl1azin">
        Skip to content
      </a>
      <AnnouncementBar data-id="element-358" data-mp="k51rvo7qjid" />
      <Header data-id="element-359" data-mp="3rxht9jokbnoh" />
      <main id="main" className="flex-1" data-id="element-360" data-mp="3rxrhb1q1rkrj">
        <Outlet data-id="element-361" data-mp="3rvwypu2904qm" />
      </main>
      <Footer data-id="element-362" data-mp="3rvoknyue2tdu" />
    </div>;
}